
























































































import { Component, Vue, Watch } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
/* 以下画面固有 */
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { applicationFormModule } from '../store/modules/ApplicationForm';
import { processHistoriesModule } from '../store/modules/ProcessHistories';
// 定数
import { UketsukeConstants } from '../fixed/UketsukeConstants';
import { UketsukeScreenName } from '../fixed/UketsukeScreenName';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class ProcessHistoriesSearch extends ApiAccessBase {
  // 拡張パネルの設定（検索条件）
  private searchPanel: number[] = [0];  //初期表示展開
  // 検索結果ヘッダの設定
  private headers = [{}];
  //ID設定変数
  private createElementId: string = '';
  private searchElementId: string = '';
  // ページネーション部品の初期値設定
  private page = 1;  // 初めに表示するページの番号（基本的に1で固定）
  private itemPerPage = 10; // 1ページあたりに表示するレコードの数
  private pageCount =  0; // ページカウントの初期化(0固定)

  private title: string = '';

  // 画面初期化処理
  // component生成時に実行
  private created() {
    this.screenTitle = '申請履歴検索';
    // 使用する可変項目の名前を指定(複数指定可)
    if (applicationFormModule.CHECK_TYPE_CONST) {
      this.createElementId = 'search_histories_const';
      this.searchElementId = 'search_result_histories_const';
      this.title = this.screenTitle + '（建設工事）';
    } else if (applicationFormModule.CHECK_TYPE_CONSUL) {
      this.createElementId = 'search_histories_consul';
      this.searchElementId = 'search_result_histories_consul';
      this.title = this.screenTitle + '（建設コンサル）';
    } else {
      this.createElementId = 'search_histories_goods';
      this.searchElementId = 'search_result_histories_goods';
      this.title = this.screenTitle + '（物品・役務）';
    }
    this.setVariablecolsState([this.createElementId]);
    const path: string = UketsukeConstants.PRO_HISTRIES_PATH + '/init/search';

    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        //検索結果.ボタンの設定
        this.headers.shift(); //先頭の空白列削除
        //検索結果.DBから展開
        for (const item of this.variablecols[this.searchElementId] ) {
          this.headers.push({text: item.label,
                            align: item.align,
                            sortable: item.sortable,
                            value: item.name,
                            width: item.width,
                            } );
        }
        this.headers.push(
        {text: '詳細', align: 'center', sortable: false, value: 'check', width: 90},
        );
        // 再検索
        if (processHistoriesModule.CHECK_RE_SEARCH_PROCESS_HISTORIES) {
          this.formData = processHistoriesModule.GET_FORM_DATA;
          this.syncFormDataToVariableCols();
          this.search();
        }
      }
    });
  }

/**
 * 戻るボタン（戻るボタン押下時）
 */
  private returnPrevious() {
    processHistoriesModule.resetFormData();
    // 遷移元設定
    processHistoriesModule.setTransitionSourceScreen(UketsukeScreenName.SEARCH_PRO_HISTRIES);
    router.push({ name: 'applicationTraderSearch' });
  }

  /**
   * 申請履歴の検索
   * (検索ボタン押下時に発火)
   */
  private search() {
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      return;
    }
    this.apiAccess(UketsukeConstants.PRO_HISTRIES_PATH + '/search/' + applicationFormModule.GET_APP_TYPE + '/' + this.searchElementId, Constants.API_METHOD_POST, true, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
          processHistoriesModule.setFormData(this.formData);
          // 検索一覧の先頭へジャンプ
          this.hrefElement('searchResults', -50);
      } else {
        // TOPへジャンプ
        this.hrefElement('proHistoriesSearch', -50);
      }
    });
  }

  /**
   * 検索条件のクリア
   */
  private reset() {
    this.resetForm(this.$refs.form);
    this.resultData = [];
    const path: string = UketsukeConstants.PRO_HISTRIES_PATH + '/init/search';
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
      }
    });
  }

  /**
   * 申請履歴の閲覧（申請履歴ボタン押下時）
   */
  private historieso(traderId : string ) {
    processHistoriesModule.setTraderId(traderId);
    // 遷移元設定
    processHistoriesModule.setTransitionSourceScreen(UketsukeScreenName.SEARCH_PRO_HISTRIES);
    router.push({ name: 'processHistories' });
  }
}
